import { createElement } from "react";
import "slick-carousel";
import {generateVectorPosition} from '../../../../client/utils/vector-position'
class WidgetComunityPartner extends elementorModules.frontend.handlers.Base {
    getDefaultSettings() {
        return {
            selectors: {
                avatars: ".ecf-community-partners__avatar-slide-list",
                avatarItem:".ecf-community-partners__avatar-slide-item",
                processBar: ".ecf-community-partners__process-bar-percent",
                img: ".background-img-position .img-position-item", 
            },
        };
    }

    getDefaultElements() {
        const selectors = this.getSettings("selectors");
        return {
            $avatars: this.$element.find(selectors.avatars),
            $avatarItem: this.$element.find(selectors.avatarItem),
            $processBar: this.$element.find(selectors.processBar),
            $img: this.$element.find(selectors.img),
        };
    }

    setProcessPercent(slideCount, curentSlide = 0) {
        let processBar = this.elements.$processBar
        let onProgress = curentSlide + 4;
        let loadProgress = (onProgress / slideCount) * 100
        processBar && processBar.css('width', loadProgress + '%')
    }

    initSlide (slide,lengthSliderItem){
        let THIS = this;
        let widthDevice = window.outerWidth;
        if(slide){
            slide
            .on('init', function(event, slick) {
                THIS.setProcessPercent(slick.slideCount);
            })
            .slick({
                dots: false,
                infinite: false,
                speed: 500,
                slidesToShow: 4,
                slidesToScroll: 1,
                variableWidth: true,
                nextArrow:
                    '<button type="button" class="slick-next ecf-slider-arrow ecf-slider-arrow-slide-next">Next</button>',
                prevArrow:
                    '<button type="button" class="slick-prev ecf-slider-arrow ecf-slider-arrow-slide-prev">Previous</button>',
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            variableWidth: false,
                            slidesToShow: 5,
                            slidesToScroll: 1,
                            dots: true
                        }
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                            dots: true
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            variableWidth: false,
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            dots: true,
                        }
                    }
                ]
            }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                THIS.setProcessPercent(slick.slideCount, nextSlide);
            })
            if(lengthSliderItem%4 != 0 && (widthDevice < 1024 && widthDevice > 767)){
                for(let i=0;i< parseInt(lengthSliderItem%4);i++){
                    slide.slick('slickAdd', '<div><div><div class="slick-item"></div></div></div>')
                }
                
                
            }
        }
    }

    getDataObject(element){
        if( typeof element !== 'undefined'){
            return JSON.parse(atob(element.getAttribute('data-information')))
        }else{
            return {}
        }
    }

    clearModal() {
        let bodyPartnerModal = document.getElementById('partner-modal');
        let htmlDOM = document.querySelector('html')
        let bodyDOM = document.querySelector('body')

        htmlDOM.classList.remove('disable-scroll--mb')
        bodyDOM.classList.remove('disable-scroll--mb')
        bodyPartnerModal && bodyPartnerModal.remove();
    }

    handleCloseModal(modal){
        let THIS = this;
        let parent = modal.querySelector('.ecf-community-partners-col-small')
        let bg = parent.querySelector('.ecf-community-partners-col-small-bg')
        let close = parent.querySelector('.ecf-community-partners__details--close')
        let partner_container = document.querySelector('.ecf-community-partners__container');

        bg.addEventListener('click',()=>{
            parent.classList.remove('active')
            partner_container.classList.remove('active');
            THIS.clearModal();
        })
        close.addEventListener('click',()=>{
            parent.classList.remove('active')
            partner_container.classList.remove('active');
            THIS.clearModal();
        })
    }

    handleClick(data,$this){
        let widthDevice = window.outerWidth;
        if(typeof data ==="object"){
            let detailsSetting = document.querySelector('.ecf-community-partners__details')
            let parent = document.querySelector('.ecf-community-partners-col-small')
            let partner_container = document.querySelector('.ecf-community-partners__container');
            let htmlDOM = document.querySelector('html')
            let bodyDOM = document.querySelector('body')

            // detailsSetting.classList.add('d-none')
            detailsSetting.innerHTML = $this.detailsTemplate(data)

            // parent.classList.add('active')
            partner_container.classList.add('active');

            // Render modal on body
            if(widthDevice<1025){
                let cloneParent = parent.cloneNode(true);

                let modal = document.createElement("div")
                modal.classList.add('ecf-community-partners')
                modal.id = "partner-modal"
                modal.appendChild(cloneParent);
    
                bodyDOM.appendChild(modal)
                htmlDOM.classList.add('disable-scroll--mb')
                bodyDOM.classList.add('disable-scroll--mb')
    
                let bodyPartnerModal = document.getElementById('partner-modal');
    
                $this.handleCloseModal(modal);
                setTimeout(()=>{
                    // detailsSetting.classList.remove('d-none')
                    bodyPartnerModal.querySelector('.ecf-community-partners-col-small').classList.add('active')
                },200)
            }
            
            
            
        }
    }

    detailsTemplate(data){
        let {image,title, content,collaboration_period,target_group,programmes} = data
        let target_string = '';
        
        if(target_group && target_group.length > 0) {
            target_string = target_group.map(e => e.name);
            target_string = target_string.join(', ');
        }

        const PROGRAMMES = programmes.map(item => {
            let {title,link} = item
            return `
                <p>
                    <a class="ecf-link" href="${link}">
                        ${title}
                    </a>
                </p>
            `
        }).join('\n')
        return `
              <div class="ecf-community-partners__details--close">
                    <i class="fal fa-times"></i>
             </div>
             ${image}
             <h3 class="ecf-community-partners__details-title">${title}</h3>
             <div class="ecf-community-partners__details-content">${content}</div>
             <div class="ecf-community-partners__details-info">
                <div class="ecf-community-partners__details-info-period">
                      <span class="title">Collaboration period</span>
                      <strong>${collaboration_period}</strong>
                </div>
                <div class="ecf-community-partners__details-info-period">
                      <span class="title">Target group</span>
                      <strong>${target_string}</strong>
                </div>
             </div>
             <div class="ecf-community-partners__details-line"></div>
             <div class="ecf-community-partners__details-programmes">
                    <h5>Programmes we collaborated on</h5>
                    ${PROGRAMMES}
             </div>
        `
    }

    convertHTMLArrayToPrototypeArray(classDOM,classParent){
        let convertString = classDOM.toString();
        let DOM = classParent.querySelectorAll(convertString);
        return Array.prototype.slice.call(DOM)
    }

    bindEvents() {
        const THIS = this;
        let img_abs = this.elements.$img;
        let avatars = this.elements.$avatars
        let avatarItemLength = this.elements.$avatars.length;
        let avatarItems = THIS.convertHTMLArrayToPrototypeArray('.ecf-community-partners__avatar',avatars[0])
        img_abs =  Array.prototype.slice.call(img_abs);
        if(img_abs.length!=0) {
            img_abs.forEach(item => {
              let dataPosition = item.getAttribute('data-position');
              let dataResponsive = item.getAttribute('data-responsive');
              let defaultObj = JSON.parse(atob(dataPosition))
              let responsive = JSON.parse(atob(dataResponsive))
              generateVectorPosition(defaultObj, responsive, item);
          });
        }
        
        for(const [index,avatar] of avatarItems.entries()){
            if(jQuery(window).width() < 992){
                for(let i = 0; i < avatarItems.length -1; i++){
                    avatarItems[i].classList.remove('active')
                }
            }
            avatar.addEventListener('click',()=>{
            for(let i = 0; i < avatarItems.length -1; i++){
                avatarItems[i].classList.remove('active')
            }
            avatar.classList.add('active')
            let data = THIS.getDataObject(avatar)
            THIS.handleClick(data,THIS)
            })
        }
        THIS.initSlide(avatars,avatarItemLength)
    }
}

jQuery(window).on("elementor/frontend/init", () => {
    const addHandler = ($element) => {
        elementorFrontend.elementsHandler.addHandler(WidgetComunityPartner, {
            $element,
        });
    };

    elementorFrontend.hooks.addAction(
        "frontend/element_ready/ecf_community_partner.default",
        addHandler
    );
});
